import * as utility from '../../utils/utility';

export default class RecipeContent {
	constructor(recipe) {
		this.recipe = recipe;
	}

	getTitle() {
		return this.recipe.title;
	}

	getNumVotes() {
		return parseInt(this.recipe.recipeDetails.recipeDetailRatingGroup.recipeDetailRatingNumVotes || 0, 10);
	}

	getTotalRatings() {
		return parseInt(this.recipe.recipeDetails.recipeDetailRatingGroup.recipeDetailRatingTotalRatings || 0, 10);
	}

	getAverageRating() {
		return parseFloat(this.recipe.recipeDetails.recipeDetailRatingGroup.recipeDetailRatingAvgScore || 0, 10);
	}

	getRecipeId() {
		return this.recipe.databaseId;
	}

	getImage() {
		const image = this.recipe.featuredImage?.node.mediaItemUrl;
		return image !== null ? image : null;
	}

	getPrepSteps() {
		const prepSteps = this.recipe.recipeDetails.recipeDetailPreparationStepRepeater;

		if (utility.arrayHasItems(prepSteps)) {
			return this.recipe.recipeDetails.recipeDetailPreparationStepRepeater.filter(
				(prep) => prep.recipeDetailPreparationStep !== null,
			);
		}

		return null;
	}
}
